import React, { useState } from "react";
import { useFormik } from "formik";
import { yupSchemaStep7 } from "schemas/yupSchema";
import { goToTop, checkIfEmptyObject } from "helpers/helpers";
import { prepareDataStep7, prepareDataStep7PIF } from "helpers/PrepareData";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import { toast } from "react-toastify";
import ProgressBar from "react-bootstrap/ProgressBar";
import UploadCamera from "components/UploadCamera";
import UploadFile from "components/UploadFile";
import NavigateButtons from "components/NavigateButtons";

export default function Step7({ currentStep, setCurrentStep, stepsState, persistState }) {
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
         isPIF: stepsState.step4.isPIF,
         fileCLCPOD: stepsState.step7.fileCLCPOD,
      },
      validationSchema: yupSchemaStep7,
      onSubmit: values => {
         startProgressBar();
         goToTop();
         saveData(values);
      },
   });

   const [progress, setProgress] = useState(10);
   const [showProgressBar, setShowProgressBar] = useState(false);

   const saveData = async values => {
      setShowProgressBar(true);
      // console.log("values7", stepsState);
      var opportunityId = stepsState.opportunityId;
      if (opportunityId === undefined || opportunityId === null) {
         console.log('opportunityId is undefined or null');
         toast.error("Va rugam sa incercati din nou.");
      }
      const isEmptyObject = checkIfEmptyObject(values.fileCLCPOD);
      const allData = {
         opportunityId: stepsState.opportunityId,
         isPIF: stepsState.step4.isPIF,
         ...values
      };
      //daca exista fisierul CLCPOD atunci se face upload la API pentru ocerizare daca nu treci mai departe si salveaza in state raspuns gol
      if (!isEmptyObject) {
         const isPIF = stepsState.step4.isPIF
         const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS7, RequestMethod.POST, {
            data: await prepareDataStep7PIF(allData, isPIF)
            // headers: [{ name: "Content-Type", value: "multipart/form-data" }],
         });

         //orice raspuns ar fi salvez poza in state
         persistState(prevState => {
            return {
               ...prevState,
               step7: {
                  ...prevState.step7,
                  fileCLCPOD: values.fileCLCPOD,
               },
            };
         });

         if (response.isSuccess) {
            // daca functioneaza ocerizarea atunci actuualizez state-ul pentru step-ul 8 ( POD/CLC ) **note: am pus mai mare > 0 deoarece daca factura are cod de bare confidence-ul este 0.0xx
            if (response.response.predictionOutput.labels?.CLC?.confidence > 0) {
               persistState(prevState => {
                  return {
                     ...prevState,
                     step7: {
                        ...prevState.step7,
                        fileCLCPOD: values.fileCLCPOD,
                     },
                     step8: {
                        ...prevState.step8,
                        pod: response.response.predictionOutput.labels.CLC.text,
                     },
                  };
               });
            }
            window.dataLayer.push({ event: "pas_7_casnici", info: { pagina: "step-7", finalizat: "da" } })
            setCurrentStep(currentStep + 1);
            localStorage.setItem("sessionCurrentStep", currentStep + 1);
         } else {
            toast.error("A aparut o eroare la incarcarea datelor locului de consum. Va rugam incercati din nou.");
         }
         //daca nu exista poza cu CLC/POD atunci treci mai departe
      } else {
         window.dataLayer.push({ event: "pas_7_casnici", info: { pagina: "step-7", finalizat: "da" } })
         setCurrentStep(currentStep + 1);
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
      }

      clearProgressBar();
      setShowProgressBar(false);
   };

   const clearProgressBar = () => {
      setProgress(5);
   };

   const startProgressBar = () => {
      clearProgressBar();
      const interval = setInterval(() => {
         setProgress(prevProgress => {
            if (prevProgress >= 100) {
               clearInterval(interval);
               return 95;
            } else {
               return prevProgress + 10;
            }
         });
      }, 4000);
   };

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-7">
                      {stepsState.step4.isPIF === false ? (
                     <h2 className="first_title">Datele locului de consum</h2>
                        ) : (
                     <h2 className="first_title">Avizul tehnic de racordare eliberat pentru locul de consum</h2>
                        )}
                     {showProgressBar ? (
                        <div className="pb-50">
                           <p className="mt-20 text-center">În acest moment se procesează datele locului de consum. Te rugăm să aștepți.</p>
                           <ProgressBar animated min={0} max={100} now={progress} />
                        </div>
                     ) : (
                        <>
                           <p className="text-center">
                                {stepsState.step4.isPIF === false ? (
                                   <>
                                       Alege una dintre opțiunile de mai jos pentru a fotografia sau încărca o copie clară cu factura de gaze naturale de la
                                       furnizorul tău actual, care să includă Codul Locului de Consum (CLC). Te rugăm să acoperi sau să ștergi prețul gazelor
                                       naturale de pe aceasta. Dacă nu dorești să încarci o fotografie, poți să treci la pasul următor unde vei introduce
                                       manual Codul Locului de Consum ( CLC ).{" "}
                                       <strong>Te sfătuim să te asiguri că datele pe care le introduci sunt corecte.</strong>
                                   </>
                                 ) : (
                                       <>
                                            Alege una dintre opțiunile de mai jos pentru a fotografia sau încărca o copie clară a avizului tehnic de racordare (ATR) primit de la distribuitorul tău,
                                            care să includă Codul Locului de Consum (CLC).{" "}
                                            <strong>Te sfătuim să te asiguri că datele pe care le introduci sunt corecte.</strong>
                                       </>
                                    )}
                               </p>
                           <form onSubmit={formik.handleSubmit}>
                              {stepsState.step4.isPIF === false ? (
                                  <div className="row text-center mt-50">
                                           <UploadCamera fileName={"photoCLCPOD.jpeg"} name={"fileCLCPOD"} setFieldValue={formik.setFieldValue} />
                                           <UploadFile
                                              name={"fileCLCPOD"}
                                              setFieldValue={formik.setFieldValue}
                                              value={formik.values.fileCLCPOD}
                                              error={formik.errors.fileCLCPOD}
                                              touched={formik.touched.fileCLCPOD}
                                           />
                              </div>
                               ) : (
                                  <div className="row text-center mt-50">
                                           <UploadCamera fileName={"photoCLCPOD.jpeg"} name={"fileCLCPOD"} setFieldValue={formik.setFieldValue} />
                                           <UploadFile
                                              name={"fileCLCPOD"}
                                              setFieldValue={formik.setFieldValue}
                                              value={formik.values.fileCLCPOD}
                                              error={formik.errors.fileCLCPOD}
                                              touched={formik.touched.fileCLCPOD}
                                           />
                              </div>
                               )}

                              <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} />
                           </form>
                        </>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
